// @core/api/endpoints/search/index_document.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  IndexDocumentRequest,
  IndexDocumentResponse,
} from '../../../types/search';

const BASE_PATH = '/search';

/**
 * Index a document
 * Indexes a single document into the search engine. Used by the internal indexing pipeline.
 */
export async function IndexDocument(
  data: IndexDocumentRequest,
  options?: RequestOptions
): Promise<IndexDocumentResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/search/documents`;
  const requestOptions = options;
  return client.post<IndexDocumentResponse>(requestPath, data, requestOptions);
}
